function lhm_initProgressBar(progress, { getItems, getActiveIndex, scrollToItem, stepItem }) {
    if (!progress) {
        return null;
    }

    const fill = progress.querySelector('.progressBarFill');

    function update() {
        const items = getItems();
        const total = items.length;

        if (total === 0) {
            return;
        }

        const activeIndex = getActiveIndex();
        const segmentWidthPercent = 100 / total;

        if (fill) {
            fill.style.width = segmentWidthPercent + '%';
            fill.style.left = (segmentWidthPercent * activeIndex) + '%';
        }

        progress.setAttribute('aria-valuemax', total);
        progress.setAttribute('aria-valuenow', activeIndex + 1);
    }

    progress.addEventListener('click', (e) => {
        const items = getItems();
        const total = items.length;

        if (total === 0) {
            return;
        }

        const rect = progress.getBoundingClientRect();
        const ratio = rect.width > 0 ? Math.min(1, Math.max(0, (e.clientX - rect.left) / rect.width)) : 0;
        const index = Math.min(total - 1, Math.floor(ratio * total));

        progress.focus({ preventScroll: true });
        scrollToItem(items[index]);
    });

    progress.addEventListener('keydown', (e) => {
        const items = getItems();

        if (e.key === 'ArrowRight') {
            e.preventDefault();
            stepItem(1);
        }

        if (e.key === 'ArrowLeft') {
            e.preventDefault();
            stepItem(-1);
        }

        if (e.key === 'Home') {
            e.preventDefault();
            scrollToItem(items[0]);
        }

        if (e.key === 'End') {
            e.preventDefault();
            scrollToItem(items[items.length - 1]);
        }
    });

    return { update };
}

window.lhm_initProgressBar = lhm_initProgressBar;
